<template>
  <div class="page">
    <sunset-note-stats-query-bar
        v-slot="{ params, meta, query }"
        path-base="/sunset/reports/note-stats/totals"
    >
      <section>
        <h2>Global stats</h2>

        <NoteStatsCsvButton mode="totals-global" :params="params" :query="query" />

        <NotesQuickLink mode='notes-global' :params="params" :query="query" />

        <!-- refactored: pass params/meta/query directly -->
        <CoreSummaryTable :params="params" :meta="meta" :query="query" />
      </section>
    </sunset-note-stats-query-bar>
  </div>
</template>

<script>
import CoreSummaryTable from './components/aggregated_summary/global_totals.vue';
import UserSummaryTable from './components/aggregated_summary/leaderboard.vue';
import loadingCube from 'loaders/record_loader.vue';
import SunsetNoteStatsQueryBar from 'pages/sunset/reports/notestats/components/shared/query_controls.vue';
import NotesQuickLink from 'pages/sunset/reports/notestats/components/shared/notes_link_button.vue';
import NoteStatsCsvButton from 'pages/sunset/reports/notestats/components/shared/csv_button.vue';

export default {
  name: 'aggregated_summary_page',
  components: {
    NoteStatsCsvButton,
    NotesQuickLink,
    SunsetNoteStatsQueryBar,
    loadingCube,
    CoreSummaryTable,
    UserSummaryTable,
  },
};
</script>

<style lang="scss" scoped>
@use "./scss/shared" as *;
</style>
